export default "__VITE_ASSET__QyyW6hAF__"